const Profile = () => import(/* webpackChunkName: "v-misc" */ '@/components/page/Profile')
const Notifications = () => import(/* webpackChunkName: "v-misc" */ '@/components/page/Notifications')
const Actions = () => import(/* webpackChunkName: "v-misc" */ '@/components/page/Actions')
const About = () => import(/* webpackChunkName: "v-misc" */ '@/components/page/About')
const Settings = () => import(/* webpackChunkName: "v-misc" */ '@/components/page/Settings')

const routes = [
  {
    // Profile page
    path: 'profile/:id',
    component: Profile,
    props: true
  }, {
    // Notifications page
    path: 'notifications',
    component: Notifications
  }, {
    // Activity logs page
    path: 'actions',
    component: Actions,
    meta: {
      roles: ['SUPER_ADMIN']
    }
  }, {
    // About page
    path: 'about',
    component: About
  }, {
    // Settings page
    path: 'settings',
    component: Settings,
    meta: {
      menu: 'settings'
    }
  }
]

export default routes
